import { Delta } from 'quill/core';
import { getDefaultAttachmentMentionText } from '../formats/AttachmentMention';

const deltaToText = (content: Delta | Delta['ops']) => {
  const delta = new Delta(content);
  // eslint-disable-next-line @typescript-eslint/no-base-to-string
  return delta
    .map((op) => {
      if (typeof op.insert === 'string') {
        return op.insert;
      }
      if (
        typeof op.insert === 'object' &&
        op.insert['attachment-mention'] &&
        Array.isArray(op.insert['attachment-mention'])
      ) {
        return (
          op.attributes?.['mention-text'] ??
          getDefaultAttachmentMentionText(op.insert['attachment-mention'])
        );
      }
      return op.attributes?.content || '';
    })
    .join('');
};

export default deltaToText;
